import React, { PropsWithChildren } from 'react'

import { FieldTitle } from 'src/pages/Policies/commons'

export { default as PositiveIntegerField } from './PositiveIntegerField/PositiveIntegerField'
export { default as MultiSelectField } from './MultiSelectField/MultiSelectField'

export interface IFieldProps {
  disabled?: boolean
  id?: string
  inputProps?: { [key: string]: string }
  title?: string
  tooltip?: string
}

export const Field = function (props: PropsWithChildren<IFieldProps>) {
  return (
    <div id={props.id} style={{ display: 'flex', flexDirection: 'column' }}>
      {/* We test with a simple equality against undefined to handle both undefined and null cas but exclude '' */}
      {props.title != undefined && <FieldTitle title={props.title} tooltip={props.tooltip} />}
      {props.children}
    </div>
  )
}
